import React, { type ReactNode } from 'react'

import { Dashboard, PageLayout, SideSummary } from '@components/common'
import { BackButton } from '@fourthwall/components'
import { isWebView } from '@fourthwall/utils'
import { useFocusFirstErrorOnSubmit } from '@fourthwall/utils/dist/formik'
import { routing } from '@utils/routing'

import { useTiers } from '../../../Perks/hooks/useTiers'
import { PostAccess } from '../../modules/PostAccess'
import { PostTypeFields } from '../../modules/PostTypeFields'
import { TagsFields } from '../../modules/TagsFields'
import * as S from './PostCreateLayout.styled'

type Props = {
  disabled?: boolean
  children: ReactNode
}

export const PostCreateLayout = ({ disabled, children }: Props) => {
  const { tiers } = useTiers()

  useFocusFirstErrorOnSubmit()

  if (!tiers) {
    return null
  }

  return (
    <PageLayout
      rightContent={
        <SideSummary>
          <PostAccess tiers={tiers} showNotification disabled={disabled} />
        </SideSummary>
      }
      leftContent={
        <>
          <PostTypeFields disabled={disabled} />
          {children}
          <TagsFields disabled={disabled} />
        </>
      }
    >
      <S.HeaderContainer>
        <Dashboard.ItemViewHeader
          name="Create a new post"
          backButton={
            isWebView() ? undefined : (
              <BackButton label="Back" to={routing.memberships.posts.self} />
            )
          }
        />
      </S.HeaderContainer>
    </PageLayout>
  )
}
